<template>
    <div>
        <loader v-if="isLoading" />
        <template v-else-if="isDisabled">
            <div class="input disabled">{{ $t(`country.${value}`) }}</div>
        </template>
        <template v-else>
            <div class="control is-expanded">
                <span class="select is-fullwidth">
                    <select :value="value" @input="onChange">
                        <option :value="null" disabled>{{ $t('country.select') }}</option>
                        <option v-for="(option, key) in options" :value="option.alpha2Code" :key="key">
                            {{ option.countryTranslation }}
                        </option>
                    </select>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'countriesSelect',
    props: {
        isDisabled: {
            type: Boolean,
        },
        value: {
            type: [String, Object],
        },
    },
    data() {
        return {
            options: [],
            isLoading: true,
        };
    },
    created() {
        this.handleI18n();
        this.getCountriesList();
    },
    methods: {
        getCountriesList: function () {
            this.isLoading = true;
            //change value field to 2 or 3; @kurt needs.
            this.options = require('./../services/countries.json');

            this.options.forEach((x) => {
                x.countryTranslation = this.$t(`country.${x.alpha2Code}`);
            });

            this.options.sort((a, b) => {
                return a.countryTranslation.localeCompare(b.countryTranslation);
            });

            this.isLoading = false;
        },
        onChange(event) {
            var value = event.target.value;
            this.$emit('input', value);
        },
        async handleI18n() {
            if (this.$i18n) {
                //only if i18n is initiated
                let currentLang = this.$i18n.locale;
                let messages = this.$i18n.messages;

                if (messages[currentLang] && !messages[currentLang].countries) {
                    //only load the current langauge and when not already added
                    const lang = require(`./../i18n/countries.${currentLang}.json`);
                    this.$i18n.setLocaleMessage(currentLang, {
                        ...messages[currentLang],
                        ...lang,
                    });
                }
            }
        },
    },
    i18n: {
        messages: {
            en: {
                ...require('./../i18n/countries.en.json'),
            },
            fr: {
                ...require('./../i18n/countries.fr.json'),
            },
            nl: {
                ...require('./../i18n/countries.nl.json'),
            },
        },
    },
};
</script>
